/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlarmClock: {
  name: 'alarm-clock';
  data: string;
} = {
  name: 'alarm-clock',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.832 1.445a1 1 0 0 1-.277 1.387l-3 2a1 1 0 1 1-1.11-1.664l3-2a1 1 0 0 1 1.387.277Zm11.723-.277a1 1 0 1 0-1.11 1.664l3 2a1 1 0 0 0 1.11-1.664l-3-2ZM4 13a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 3 2 7.477 2 13s4.477 10 10 10 10-4.477 10-10S17.523 3 12 3Zm1 6a1 1 0 1 0-2 0v3a2 2 0 0 0 2 2h3a1 1 0 1 0 0-2h-3V9Z" fill="currentColor"/></svg>`,
};
